import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import employeedashboard from '@/components/employeedashboard'
import employees from '@/components/employees'
import holidays from '@/components/holidays'
import leaves from '@/components/leaves'
import leavesemployee from '@/components/leavesemployee'
import chat from '@/components/chat'
import voicecall from '@/components/voicecall'
import videocall from '@/components/videocall'
import outgoingcall from '@/components/outgoingcall'
import incomingcall from '@/components/incomingcall'
import events from '@/components/events'
import contacts from '@/components/contacts'
import inbox from '@/components/inbox'
import filemanager from '@/components/filemanager'
import leavesettings from '@/components/leavesettings'
import performancesettings from '@/components/performancesettings'
import approvalsettings from '@/components/approvalsettings'
import toxboxsettings from '@/components/toxboxsettings'
import cronsettings from '@/components/cronsettings'
import attendance from '@/components/attendance'
import attendanceemployee from '@/components/attendanceemployee'
import departments from '@/components/departments'
import designations from '@/components/designations'
import timesheet from '@/components/timesheet'
import overtime from '@/components/overtime'
import clients from '@/components/clients'
import projects from '@/components/projects'
import tasks from '@/components/tasks'
import taskboard from '@/components/taskboard'
import leads from '@/components/leads'
import tickets from '@/components/tickets'
import estimates from '@/components/estimates'
import invoices from '@/components/invoices'
import payments from '@/components/payments'
import expenses from '@/components/expenses'
import providentfund from '@/components/providentfund'
import taxes from '@/components/taxes'
import salary from '@/components/salary'
import salaryview from '@/components/salaryview'
import payrollitems from '@/components/payrollitems'
import policies from '@/components/policies'
import expensereports from '@/components/expensereports'
import invoicereports from '@/components/invoicereports'
import paymentsreports from '@/components/paymentsreports'
import projectreports from '@/components/projectreports'
import taskreports from '@/components/taskreports'
import userreports from '@/components/userreports'
import payslipreports from '@/components/payslipreports'
import employeereports from '@/components/employeereports'
import attendancereports from '@/components/attendancereports'
import attendreports from '@/components/attendreports'
import leavereports from '@/components/leavereports'
import dailyreports from '@/components/dailyreports'
import performanceindicator from '@/components/performanceindicator'
import performance from '@/components/performance'
import performanceappraisal from '@/components/performanceappraisal'
import goaltracking from '@/components/goaltracking'
import goaltype from '@/components/goaltype'
import training from '@/components/training'
import trainers from '@/components/trainers'
import trainingtype from '@/components/trainingtype'
import promotion from '@/components/promotion'
import resignation from '@/components/resignation'
import termination from '@/components/termination'
import assets from '@/components/assets'
import jobs from '@/components/jobs'
import jobapplicants from '@/components/jobapplicants'
import knowledgebase from '@/components/knowledgebase'
import activities from '@/components/activities'
import users from '@/components/users'
import settings from '@/components/settings'
import profile from '@/components/profile'
import clientprofile from '@/components/clientprofile'
import tablesbasic from '@/components/tablesbasic'
import datatables from '@/components/datatables'
import formbasicinputs from '@/components/formbasicinputs'
import forminputgroups from '@/components/forminputgroups'
import formhorizontal from '@/components/formhorizontal'
import formvertical from '@/components/formvertical'
import formmask from '@/components/formmask'
import formvalidation from '@/components/formvalidation'
import components from '@/components/components'
import search from '@/components/search'
import faq from '@/components/faq'
import terms from '@/components/terms'
import privacypolicy from '@/components/privacypolicy'
import blankpage from '@/components/blankpage'
import subscriptions from '@/components/subscriptions'
import subscriptionscompany from '@/components/subscriptionscompany'
import subscribedcompanies from '@/components/subscribedcompanies'
import error404 from '@/components/error404'
import error500 from '@/components/error500'
import ticketview from '@/components/ticketview'
import themesettings from '@/components/themesettings'
import salarysettings from '@/components/salarysettings'
import rolespermissions from '@/components/rolespermissions'
import register from '@/components/register'
import projectview from '@/components/projectview'
import projectlist from '@/components/projectlist'
import otp from '@/components/otp'
import notificationssettings from '@/components/notificationssettings'
import mailview from '@/components/mailview'
import login from '@/components/login'
import lockscreen from '@/components/lockscreen'
import localization from '@/components/localization'
import leavetype from '@/components/leavetype'
import knowledgebaseview from '@/components/knowledgebaseview'
import jobview from '@/components/jobview'
import joblist from '@/components/joblist'
import jobdetails from '@/components/jobdetails'
import invoiceview from '@/components/invoiceview'
import invoicesettings from '@/components/invoicesettings'
import forgotpassword from '@/components/forgotpassword'
import estimateview from '@/components/estimateview'
import employeeslist from '@/components/employeeslist'
import emailsettings from '@/components/emailsettings'
import editinvoice from '@/components/editinvoice'
import editestimate from '@/components/editestimate'
import createinvoice from '@/components/createinvoice'
import createestimate from '@/components/createestimate'
import clientslist from '@/components/clientslist'
import changepassword from '@/components/changepassword'
import compose from '@/components/compose'
import categories from '@/components/categories'
import subcategory from '@/components/subcategory'
import budgets from '@/components/budgets'
import budgetexpenses from '@/components/budgetexpenses'
import budgetrevenues from '@/components/budgetrevenues'
import shiftschedule from '@/components/shiftschedule'
import shiftlist from '@/components/shiftlist'
import userdashboard from '@/components/userdashboard'
import jobsdashboard from '@/components/jobsdashboard'
import alljobs from '@/components/alljobs'
import savedjobs from '@/components/savedjobs'
import appliedjobs from '@/components/appliedjobs'
import interviewing from '@/components/interviewing'
import offeredjobs from '@/components/offeredjobs'
import visitedjobs from '@/components/visitedjobs'
import archivedjobs from '@/components/archivedjobs'
import manageresumes from '@/components/manageresumes'
import shortlistcandidates from '@/components/shortlistcandidates'
import interviewquestions from '@/components/interviewquestions'
import offerapprovals from '@/components/offerapprovals'
import experiencelevel from '@/components/experiencelevel'
import candidates from '@/components/candidates'
import scheduletiming from '@/components/scheduletiming'
import aptituderesults from '@/components/aptituderesults'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: 'purple',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
    },
    {
      path: '/index',
      name: 'indexs',
      component: index,
    },
    {
      path: '/employeedashboard',
      name: 'employeedashboard',
      component: employeedashboard,
    },
    {
      path: '/employees',
      name: 'employees',
      component: employees,
    },
    {
      path: '/holidays',
      name: 'holidays',
      component: holidays,
    },
    {
      path: '/leaves',
      name: 'leaves',
      component: leaves,
    },
    {
      path: '/leavesemployee',
      name: 'leavesemployee',
      component: leavesemployee,
    },
    {
      path: '/chat',
      name: 'chat',
      component: chat,
    },
    {
      path: '/voicecall',
      name: 'voicecall',
      component: voicecall,
    },
    {
      path: '/videocall',
      name: 'videocall',
      component: videocall,
    },
    {
      path: '/outgoingcall',
      name: 'outgoingcall',
      component: outgoingcall,
    },
    {
      path: '/incomingcall',
      name: 'incomingcall',
      component: incomingcall,
    },
    {
      path: '/events',
      name: 'events',
      component: events,
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: contacts,
    },
    {
      path: '/inbox',
      name: 'inbox',
      component: inbox,
    },
    {
      path: '/filemanager',
      name: 'filemanager',
      component: filemanager,
    },
    {
      path: '/leavesettings',
      name: 'leavesettings',
      component: leavesettings,
    },
    {
      path: '/performancesettings',
      name: 'performancesettings',
      component: performancesettings,
    },
    {
      path: '/approvalsettings',
      name: 'approvalsettings',
      component: approvalsettings,
    },
    {
      path: '/toxboxsettings',
      name: 'toxboxsettings',
      component: toxboxsettings,
    },
    {
      path: '/cronsettings',
      name: 'cronsettings',
      component: cronsettings,
    },
    {
      path: '/attendance',
      name: 'attendance',
      component: attendance,
    },
    {
      path: '/attendanceemployee',
      name: 'attendanceemployee',
      component: attendanceemployee,
    },
    {
      path: '/departments',
      name: 'departments',
      component: departments,
    },
    {
        path: '/designations',
        name: 'designations',
        component: designations,
      },
      {
        path: '/timesheet',
        name: 'timesheet',
        component: timesheet,
      },
      {
        path: '/overtime',
        name: 'overtime',
        component: overtime,
      },
      {
        path: '/clients',
        name: 'clients',
        component: clients,
      },
      {
        path: '/projects',
        name: 'projects',
        component: projects,
      },
      {
        path: '/tasks',
        name: 'tasks',
        component: tasks,
      },
      {
        path: '/taskboard',
        name: 'taskboard',
        component: taskboard,
      },
      {
        path: '/leads',
        name: 'leads',
        component: leads,
      },
      {
        path: '/tickets',
        name: 'tickets',
        component: tickets,
      },
      {
        path: '/estimates',
        name: 'estimates',
        component: estimates,
      },
      {
        path: '/invoices',
        name: 'invoices',
        component: invoices,
      },
      {
        path: '/payments',
        name: 'payments',
        component: payments,
      },
      {
        path: '/expenses',
        name: 'expenses',
        component: expenses,
      },
      {
        path: '/providentfund',
        name: 'providentfund',
        component: providentfund,
      },
      {
        path: '/taxes',
        name: 'taxes',
        component: taxes,
      },
      {
        path: '/salary',
        name: 'salary',
        component: salary,
      },
      {
        path: '/salaryview',
        name: 'salaryview',
        component: salaryview,
      },
      {
        path: '/payrollitems',
        name: 'payrollitems',
        component: payrollitems,
      },
      {
        path: '/policies',
        name: 'policies',
        component: policies,
      },
      {
        path: '/expensereports',
        name: 'expensereports',
        component: expensereports,
      },
      {
        path: '/invoicereports',
        name: 'invoicereports',
        component: invoicereports,
      },
      {
        path: '/payments-reports',
        name: 'paymentsreports',
        component: paymentsreports,
      },
      {
        path: '/project-reports',
        name: 'projectreports',
        component: projectreports,
      },
      {
        path: '/task-reports',
        name: 'taskreports',
        component: taskreports,
      },
      {
        path: '/user-reports',
        name: 'userreports',
        component: userreports,
      },
      {
        path: '/payslip-reports',
        name: 'payslipreports',
        component: payslipreports,
      },
      {
        path: '/employee-reports',
        name: 'employeereports',
        component: employeereports,
      },
      {
        path: '/attendance-reports',
        name: 'attendancereports',
        component: attendancereports,
      },
      {
        path: '/attend-reports',
        name: 'attendreports',
        component: attendreports,
      },
      {
        path: '/leave-reports',
        name: 'leavereports',
        component: leavereports,
      },
      {
        path: '/daily-reports',
        name: 'dailyreports',
        component: dailyreports,
      },
      {
        path: '/performanceindicator',
        name: 'performanceindicator',
        component: performanceindicator,
      },
      {
        path: '/performance',
        name: 'performance',
        component: performance,
      },
      {
        path: '/performanceappraisal',
        name: 'performanceappraisal',
        component: performanceappraisal,
      },
      {
        path: '/goaltracking',
        name: 'goaltracking',
        component: goaltracking,
      },
      {
        path: '/goaltype',
        name: 'goaltype',
        component: goaltype,
      },
      {
        path: '/training',
        name: 'training',
        component: training,
      },
      {
        path: '/trainers',
        name: 'trainers',
        component: trainers,
      },
      {
        path: '/trainingtype',
        name: 'trainingtype',
        component: trainingtype,
      },
      {
        path: '/promotion',
        name: 'promotion',
        component: promotion,
      },
      {
        path: '/resignation',
        name: 'resignation',
        component: resignation,
      },
      {
        path: '/termination',
        name: 'termination',
        component: termination,
      },
      {
        path: '/assets',
        name: 'assets',
        component: assets,
      },
      {
        path: '/jobs',
        name: 'jobs',
        component: jobs,
      },
      {
        path: '/jobapplicants',
        name: 'jobapplicants',
        component: jobapplicants,
      },
      {
        path: '/knowledgebase',
        name: 'knowledgebase',
        component: knowledgebase,
      },
      {
        path: '/activities',
        name: 'activities',
        component: activities,
      },
      {
        path: '/users',
        name: 'users',
        component: users,
      },
      {
        path: '/settings',
        name: 'settings',
        component: settings,
      },
      {
        path: '/profile',
        name: 'profile',
        component: profile,
      },
      {
        path: '/clientprofile',
        name: 'clientprofile',
        component: clientprofile,
      },
      {
        path: '/tablesbasic',
        name: 'tablesbasic',
        component: tablesbasic,
      },
      {
        path: '/datatables',
        name: 'datatables',
        component: datatables,
      },
      {
        path: '/formbasicinputs',
        name: 'formbasicinputs',
        component: formbasicinputs,
      },
      {
        path: '/forminputgroups',
        name: 'forminputgroups',
        component: forminputgroups,
      },
      {
        path: '/formhorizontal',
        name: 'formhorizontal',
        component: formhorizontal,
      },
      {
        path: '/formvertical',
        name: 'formvertical',
        component: formvertical,
      },
      {
        path: '/formmask',
        name: 'formmask',
        component: formmask,
      },
      {
        path: '/formvalidation',
        name: 'formvalidation',
        component: formvalidation,
      },
      {
        path: '/components',
        name: 'components',
        component: components,
      },
       {
        path: '/search',
        name: 'search',
        component: search,
      },
      {
        path: '/faq',
        name: 'faq',
        component: faq,
      },
      {
        path: '/terms',
        name: 'terms',
        component: terms,
      },
      {
        path: '/privacypolicy',
        name: 'privacypolicy',
        component: privacypolicy,
      },
      {
        path: '/blankpage',
        name: 'blankpage',
        component: blankpage,
      },
      {
        path: '/subscriptions',
        name: 'subscriptions',
        component: subscriptions,
      },
      {
        path: '/subscriptionscompany',
        name: 'subscriptionscompany',
        component: subscriptionscompany,
      },
      {
        path: '/subscribedcompanies',
        name: 'subscribedcompanies',
        component: subscribedcompanies,
      },
      {
        path: '/error404',
        name: 'error404',
        component: error404,
      },
      {
        path: '/error500',
        name: 'error500',
        component: error500,
      },
      {
        path: '/ticketview',
        name: 'ticketview',
        component: ticketview,
      },
      {
        path: '/themesettings',
        name: 'themesettings',
        component: themesettings,
      },
      {
        path: '/salarysettings',
        name: 'salarysettings',
        component: salarysettings,
      },
      {
        path: '/rolespermissions',
        name: 'rolespermissions',
        component: rolespermissions,
      },
      {
        path: '/register',
        name: 'register',
        component: register,
      },
      {
        path: '/projectview',
        name: 'projectview',
        component: projectview,
      },
      {
        path: '/projectlist',
        name: 'projectlist',
        component: projectlist,
      },
      {
        path: '/otp',
        name: 'otp',
        component: otp,
      },
      {
        path: '/notificationssettings',
        name: 'notificationssettings',
        component: notificationssettings,
      },
      {
        path: '/mailview',
        name: 'mailview',
        component: mailview,
      },
      {
        path: '/login',
        name: 'login',
        component: login,
      },
      {
        path: '/lockscreen',
        name: 'lockscreen',
        component: lockscreen,
      },
      {
        path: '/localization',
        name: 'localization',
        component: localization,
      },
      {
        path: '/leavetype',
        name: 'leavetype',
        component: leavetype,
      },
      {
        path: '/knowledgebaseview',
        name: 'knowledgebaseview',
        component: knowledgebaseview,
      },
      {
        path: '/jobview',
        name: 'jobview',
        component: jobview,
      },
      {
        path: '/joblist',
        name: 'joblist',
        component: joblist,
      },
      {
        path: '/jobdetails',
        name: 'jobdetails',
        component: jobdetails,
      },
      {
        path: '/invoiceview',
        name: 'invoiceview',
        component: invoiceview,
      },
      {
        path: '/invoicesettings',
        name: 'invoicesettings',
        component: invoicesettings,
      },
      {
        path: '/forgotpassword',
        name: 'forgotpassword',
        component: forgotpassword,
      },
      {
        path: '/estimateview',
        name: 'estimateview',
        component: estimateview,
      },
      {
        path: '/employeeslist',
        name: 'employeeslist',
        component: employeeslist,
      },
      {
        path: '/emailsettings',
        name: 'emailsettings',
        component: emailsettings,
      },
      {
        path: '/editinvoice',
        name: 'editinvoice',
        component: editinvoice,
      },
      {
        path: '/editestimate',
        name: 'editestimate',
        component: editestimate,
      },
      {
        path: '/createinvoice',
        name: 'createinvoice',
        component: createinvoice,
      },
      {
        path: '/createestimate',
        name: 'createestimate',
        component: createestimate,
      },
      {
        path: '/clientslist',
        name: 'clientslist',
        component: clientslist,
      },
      {
        path: '/changepassword',
        name: 'changepassword',
        component: changepassword,
      },
      {
        path: '/compose',
        name: 'compose',
        component: compose,
      },
      {
        path: '/categories',
        name: 'categories',
        component: categories,
      },
      {
        path: '/sub-category',
        name: 'subcategory',
        component: subcategory,
      },
      {
        path: '/budgets',
        name: 'budgets',
        component: budgets,
      },
      {
        path: '/budget-expenses',
        name: 'budgetexpenses',
        component: budgetexpenses,
      },
      {
        path: '/budget-revenues',
        name: 'budgetrevenues',
        component: budgetrevenues,
      },
      {
        path: '/shift-scheduling',
        name: 'shiftscheduling',
        component: shiftschedule,
      },
      {
        path: '/shift-list',
        name: 'shiftlist',
        component: shiftlist,
      },
      {
        path: '/user-dashboard',
        name: 'userdashboard',
        component: userdashboard,
      },
      {
        path: '/jobs-dashboard',
        name: 'jobsdashboard',
        component: jobsdashboard,
      },
      {
        path: '/user-all-jobs',
        name: 'useralljobs',
        component: alljobs,
      },
      {
        path: '/saved-jobs',
        name: 'savedjobs',
        component: savedjobs,
      },
      {
        path: '/applied-jobs',
        name: 'appliedjobs',
        component: appliedjobs,
      },
      {
        path: '/interviewing',
        name: 'interviewing',
        component: interviewing,
      },
      {
        path: '/offered-jobs',
        name: 'offeredjobs',
        component: offeredjobs,
      },
      {
        path: '/visited-jobs',
        name: 'visitedjobs',
        component: visitedjobs,
      },
      {
        path: '/archived-jobs',
        name: 'archivedjobs',
        component: archivedjobs,
      },
      {
        path: '/manage-resumes',
        name: 'manageresumes',
        component: manageresumes,
      },
      {
        path: '/shortlist-candidates',
        name: 'shortlistcandidates',
        component: shortlistcandidates,
      },
      {
        path: '/interview-questions',
        name: 'interviewquestions',
        component: interviewquestions,
      },
      {
        path: '/offer-approvals',
        name: 'offerapprovals',
        component: offerapprovals,
      },
      {
        path: '/experience-level',
        name: 'experiencelevel',
        component: experiencelevel,
      },
      {
        path: '/candidates',
        name: 'candidates',
        component: candidates,
      },
      {
        path: '/schedule-timing',
        name: 'scheduletiming',
        component: scheduletiming,
      },
      {
        path: '/aptitude-results',
        name: 'aptituderesults',
        component: aptituderesults,
      }
  ],
  linkActiveClass: "active",
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js